/**
 * Shared GA4 event helper for anything beyond page_view (which Analytics.tsx
 * already handles on every route change). Same production-only, ID-gated
 * behavior, so dev servers and forks never send real events.
 *
 * Usage: trackEvent('resume_download', { source: 'header_button' })
 */
const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined
const ENABLED = Boolean(GA_ID) && import.meta.env.PROD

export function trackEvent(name: string, params: Record<string, string> = {}) {
  if (!ENABLED) return
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', name, params)
}
